import { apiGet, apiPostJSON, apiPatch, apiDelete } from 'App/Dataman';
import { SOCIAL_MEDIA_SCRAPER_PATHS } from '@/app/api/socialMediaScraper/paths';

const itemUrl = (id) => `${SOCIAL_MEDIA_SCRAPER_PATHS.coreAccounts}/${id}`;
const unwrapItem = (response) => (response?.data?.item ? { ...response, data: response.data.item } : response);

export function getCoreAccounts(params = {}) {
  return apiGet(SOCIAL_MEDIA_SCRAPER_PATHS.coreAccounts, { params });
}

export function getCoreAccount(id) {
  return apiGet(itemUrl(id)).then(unwrapItem);
}

export function createCoreAccount(data) {
  return apiPostJSON(SOCIAL_MEDIA_SCRAPER_PATHS.coreAccounts, data).then(unwrapItem);
}

export function updateCoreAccount(id, data) {
  return apiPatch(itemUrl(id), { data, headers: { 'content-type': 'application/json' } }).then(unwrapItem);
}

export function deleteCoreAccount(id) {
  return apiDelete(itemUrl(id));
}

export function createCoreAccountsBulk(items = []) {
  return apiPostJSON(`${SOCIAL_MEDIA_SCRAPER_PATHS.coreAccounts}/bulk`, { items });
}

export default {
  getList: getCoreAccounts,
  getItem: getCoreAccount,
  create: createCoreAccount,
  createBulk: createCoreAccountsBulk,
  update: updateCoreAccount,
  remove: deleteCoreAccount,
};
